import "./Successes.css";
import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import SiteHeader from "./../../components/SiteHeader";

const Successes2025 = () => {
  const styles = {
    card: {
      background: "transparent",
      borderRadius: 20,
      overflow: "hidden",
      boxShadow: "0 14px 36px rgba(0,0,0,.35)",
    },
    imgTall: { height: "400px", width: "auto", objectFit: "fit" },
    caption: {
      left: 0,
      right: 0,
      bottom: 0,
      textAlign: "left",
      background:
        "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,.55) 60%, rgba(0,0,0,.85) 100%)",
      padding: "24px 20px",
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
    },
    capTitle: { margin: 0, fontWeight: 700, fontSize: "1.15rem" },
    capText: { margin: "6px 0 0 0", fontSize: ".95rem" },
  };

  return (
    <>
      <div class="bodyContainer">
        <SiteHeader current="home" />

        <div class="homeContainer">
          <div class="container ">
            <div class="row mt-5 mb-3 justify-content-center">
              <div className="col-12 text-start mb-3">
                <button
                  type="button"
                  className="btn btn-link text-decoration-none p-0 mt-5"
                  onClick={() => window.history.back()}
                >
                  ← Επιστροφή
                </button>
              </div>
            </div>
            <div class="row mb-5 justify-content-center">
              <h1 class="text-center" style={{ marginTop: 20, marginBottom: 40 }}>
                <strong>ΕΠΙΤΥΧΙΕΣ (2025)</strong>
              </h1>
              <div class="d-flex justify-content-center text-center align-items-center mt-5 mb-5">
                <div class="text-left"   style={{width: "100%"}}>
                  <a href="https://app.ttscore.io/customer/24/event/727#" class="title">
                  <h3 id="prokrimatika"><strong>ΠΡΟΚΡΙΜΑΤΙΚΑ ΠΑΝΕΛΛΗΝΙΟΥ ΠΡΩΤΑΘΛΗΜΑΤΟΣ </strong></h3>
                  <h4 >Η Μαρία Καΐπη η πρώτη αθλήτρια ΑμεΑ που προκρίθηκε στην τελική φάση.</h4>
                  <h5>Αθήνα Σ.Ε.Φ</h5>
                  <h4><strong>ΑΘΗΝΑΪΚΟ ΠΡΑΚΤΟΡΕΙΟ ΕΙΔΗΣΕΩΝ: </strong><a href="https://www.amna.gr/sport/article/873201/SYNENTEYXI-I-Maria-Kaipi-i-proti-athlitria-AmeA-pou-prokrithike-stin-teliki-fasirn">ΣΥΝΕΝΤΕΥΞΗ</a></h4>
                </a></div>
                <div  style={{width: "100%", borderRadius: 20 }} >
                  <div style={styles.card}>
                      <Carousel >
                        <Carousel.Item>
                          <img
                          src="/images/2025/prokrimatika.jpg"
                            alt="Prokrimatika Panellhniou SEF"
                            style={styles.imgTall}
                          />
                          <Carousel.Caption style={styles.caption}>
                            <h5 style={styles.capTitle}>Προκριματικά Πανελληνίου Πρωταθλήματος • Σ.Ε.Φ</h5>
                          </Carousel.Caption>
                        </Carousel.Item>
                        </Carousel>
                  </div>
                </div>
              </div>
            
                <hr />

              <div class="d-flex justify-content-center text-center align-items-center mt-5 mb-5">
                
                <div class=""  style={{width: "100%", borderRadius: 20 }}>
                  <div style={styles.card}>
                    <Carousel interval={4000}>
                      <Carousel.Item>
                        <img
                          src="/images/2025/Panellhnio2025_1.jpg"
                          alt="Panellhnio 1"
                          style={styles.imgTall}
                        />
                        <Carousel.Caption style={styles.caption}>
                          <h5 style={styles.capTitle}>Χρυσό Μετάλλιο • Σ.Ε.Φ</h5>
                          {/* <p style={styles.capText">Σταθερή πορεία μέχρι τον τελικό και καθαρή νίκη 3–0.</p> */}
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item>
                        <img
                          src="/images/2025/Panellhnio2025_2.jpg"
                          alt="Panellhnio 2"
                          style={styles.imgTall}
                        />
                        <Carousel.Caption style={styles.caption}>
                          {/* <h5 style={styles.capTitle}>Ακαταμάχητο forehand</h5>
                          <p style={styles.capText}>Επιθετικό άνοιγμα με topspin και πίεση στο 3ο μπαλάκι.</p> */}
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item>
                        <img
                          src="/images/2025/Panellhnio2025.jpg"
                          alt="Panellhnio 3"
                          style={styles.imgTall}
                        />
                        <Carousel.Caption style={styles.caption}>
                          <h5 style={styles.capTitle}>Στιγμή απονομής</h5>
                          <p style={styles.capText}>Μια δυνατή χρονιά για την κατηγορία 7.</p>
                        </Carousel.Caption>
                      </Carousel.Item>
                    </Carousel>
                  </div>
                </div>
                <div  style={{width: "100%"}} >
                  <a href="https://drive.google.com/file/d/1iYzEdm4fWBtrbyGtMpRpVtm0t3mSiRBE/view" class="title">
                    <h3><strong>ΠΑΝΕΛΛΗΝΙΟ ΠΡΩΤΑΘΛΗΜΑ ΕΠΙΤΡΑΠΕΖΙΑΣ ΑΝΤΙΣΦΑΙΡΙΣΗΣ ΑΜΕΑ 2025</strong></h3>
                    <h4>Ατομικά Γυναικών ΤΤ6-ΤΤ10</h4>
                    <h3><strong>1η Θέση</strong></h3>
                    <div class="d-flex justify-content-center w-100 flex-row text-center align-items-baseline">
                    {/* <h6>(Σύλλογος ΠΑ.Σ.Κ.Α)</h6> */}
                    </div>
                    <h5>Αθήνα Σ.Ε.Φ</h5>
                  </a>
                </div>
              </div>
                <hr />

              <div class="d-flex justify-content-center text-center align-items-center mt-5 mb-5">
                <div style={{ width: "100%" }}><a href="https://app.ttscore.io/customer/24/event/762#" class="title">
                  <h3><strong>ΔΙΑΣΥΛΛΟΓΙΚΟ ΠΡΩΤΑΘΛΗΜΑ Β' ΕΘΝΙΚΗΣ ΓΥΝΑΙΚΩΝ 2025 (Δυτ. Ελλάδα)</strong></h3>
                  <h3>Α.Σ. Ίφιτος Πατρών: 1η Θέση</h3>
                  <h5><strong>Ε.Φ.Ο.ΕΠ.Α</strong></h5>
                </a></div>
                <div  style={{width: "100%"}}>
                  <div style={styles.card}>
                    <Carousel interval={4200}>
                      <Carousel.Item>
                        <img src="/images/2025/BEthniki1.jpg" alt="B Ethniki 1" style={styles.imgTall} />
                        <Carousel.Caption style={styles.caption}>
                          <h5 style={styles.capTitle}>Πρωταθλήτριες Δ. Ελλάδας</h5>
                          <p style={styles.capText}>Β' Εθνική Γυναικών 2025 — 1η Θέση.</p>
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item>
                        <img src="/images/2025/BEthniki2.jpg" alt="B Ethniki 2" style={styles.imgTall} />
                        <Carousel.Caption style={styles.caption}>
                          {/* <h5 style={styles.capTitle}>Η ομάδα εν δράσει</h5>
                          <p style={styles.capText}>Συνεχόμενα σερβίς με ποικιλία σπιν.</p> */}
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item>
                        <img
                          src="/images/2025/BEthniki2025Diploma.jpg"
                          alt="B Ethniki Diploma"
                          style={styles.imgTall}
                        />
                        <Carousel.Caption style={styles.caption}>
                          {/* <h5 style={styles.capTitle}>Καθαρό 3–0</h5>
                          <p style={styles.capText}>Δυναμικό ξεκίνημα στο ομαδικό.</p> */}
                        </Carousel.Caption>
                      </Carousel.Item>
                    </Carousel>
                  </div>
                </div>
              </div>

              <hr />

              <div class="d-flex justify-content-center text-center align-items-center mt-5 mb-5">
                <div class=""  style={{width: "100%", borderRadius: 20 }}>
                  <div style={styles.card}>
                    <Carousel interval={4000}>
                      <Carousel.Item>
                        <img
                          src="/images/2025/POFEPA_aponomi.jpg"
                          alt=""
                          style={styles.imgTall}
                        />
                        <Carousel.Caption style={styles.caption}>
                          <h5 style={styles.capTitle}>Χάλκινο Μετάλλιο • ΤΟΦΑΛΟΣ</h5>
                          {/* <p style={styles.capText">Σταθερή πορεία μέχρι τον τελικό και καθαρή νίκη 3–0.</p> */}
                        </Carousel.Caption>
                      </Carousel.Item>
                      
                      <Carousel.Item>
                        <img
                          src="/images/2025/POFEPA_metallia.jpg"
                          alt=""
                          style={styles.imgTall}
                        />
                        <Carousel.Caption style={styles.caption}>
                          <h5 style={styles.capTitle}>Απονομή τίτλων</h5>
                          <p style={styles.capText}></p>
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item>
                        <img
                          src="/images/2025/POFEPA2025.jpg"
                          alt=""
                          style={styles.imgTall}
                        />
                        <Carousel.Caption style={styles.caption}>
                          <h5 style={styles.capTitle}>Απολογισμός πρωταθλήματος</h5>
                          <p style={styles.capText}></p>
                        </Carousel.Caption>
                      </Carousel.Item>
                    </Carousel>
                  </div>
                </div>
                <div  style={{width: "100%"}} >
                  <a href="https://www.facebook.com/permalink.php?story_fbid=pfbid0GyDfYxwdzpy9ByPHovnuZYMY94ZK7FgGJSM4RQqKJi2nKW7BumbgztzEqk1j9EeCl&id=100015480315152" class="title">
                    <h3><strong>ΠΡΩΤΑΘΛΗΜΑ ΠΟΦΕΠΑ ΔΥΤ. ΕΛΛΑΔΑΣ 2025</strong></h3>
                    <h3>ΑΤΡΟΜΗΤΟΙ: 4η Θέση </h3> 
                    <h5><strong>Π.Ο.Φ.ΕΠ.Α</strong></h5>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <footer class="row  text-center text-lg-start mt-5">
            <div class="container p-4">
              <div class="row">
                <div class="col-lg-6 col-md-12 mb-4 mb-md-0" />
                <div class="col-lg-6 col-md-12 mb-4 mb-md-0" />
              </div>
            </div>
            <div class="text-center p-3">© 2025 Copyright</div>
          </footer>
        </div>
      </div>
    </>
  );
};

export default Successes2025;
